// utils/trelloDateUtils.js

// Parse a Trello date string into a Date in local time
export function parseLocalDate(dateString) {
  if (!dateString) return null;

  const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(dateString);
  const isMidnightUTC = /^\d{4}-\d{2}-\d{2}T00:00:00(?:\.000)?Z$/.test(
    dateString
  );

  if (isDateOnly || isMidnightUTC) {
    const [year, month, day] = dateString.split("T")[0].split("-").map(Number);
    return new Date(year, month - 1, day);
  }

  return new Date(dateString);
}

// Format a Trello date string for display in local time
export function formatLocalDate(dateString) {
  const date = parseLocalDate(dateString);
  if (!date) return "-";

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12 || 12;

  return `${month}/${day}/${year} ${hours}:${minutes}${ampm}`;
}

// Check if a Trello date string is overdue (local calendar day)
export function isOverdue(dateString) {
  if (!dateString) return false;
  const dueDate = parseLocalDate(dateString);
  if (!dueDate) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const localDue = new Date(
    dueDate.getFullYear(),
    dueDate.getMonth(),
    dueDate.getDate()
  );
  return localDue < today;
}

// Convert a Trello date string to YYYY-MM-DD for <input type="date">
export function toDateInputValue(dateString) {
  if (!dateString) return "";
  const date = parseLocalDate(dateString);
  if (!date) return "";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

// Convert YYYY-MM-DD from input back to Trello ISO string (midnight UTC)
export function toTrelloDue(dateInputValue) {
  if (!dateInputValue) return null;
  return `${dateInputValue}T00:00:00.000Z`;
}
